import { render, staticRenderFns } from "./customLabel.vue?vue&type=template&id=35034aa4&scoped=true&"
import script from "./customLabel.vue?vue&type=script&lang=js&"
export * from "./customLabel.vue?vue&type=script&lang=js&"
import style0 from "./customLabel.vue?vue&type=style&index=0&id=35034aa4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35034aa4",
  null
  
)

export default component.exports